import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { FileRoleType } from '@/common/types/ApiResponseTypes.type';
import { getDamagedAdjusterDocumentImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterDocumentImages/getDamagedAdjusterDocumentImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';
export default ({ userType }: { userType: FileRoleType }) => {
  let title = '';
  switch (userType) {
    case 'body':
    case 'damaged':
      title = 'زیاندیده';
      break;

    case 'culprit':
      title = 'مقصر';
      break;
    case 'initial':
      title = 'بیمه گذار';
      break;

    default:
      break;
  }
  return (
    <MainLayout
      title={`تصاویر / ${title}`}
      header="titleHeader"
      hasBottomPadding
    >
      <ShowAdjusterDocumentImages userType={userType} />
    </MainLayout>
  );
};

const ShowAdjusterDocumentImages = ({
  userType,
}: {
  userType: FileRoleType;
}) => {
  const { id, damagedId } = useParams();

  const { data: documentImagesList, isRefetching: getListLoading } = useQuery(
    getDamagedAdjusterDocumentImagesQueryOptions({
      damagedId: Number(damagedId),
      type: userType,
      id: Number(id),
    }),
  );
  if (getListLoading) return <LoadingPage />;
  return (
    <Box pt="1.5rem">
      <TitleDescription>تصاویر مدارک</TitleDescription>
      {documentImagesList?.length ? (
        <Flex
          gap="1rem"
          maxWidth="maxContainer"
          margin="auto"
          mt="1.5rem"
          className={grid({ columns: 2 })}
        >
          {documentImagesList?.map((image) => (
            <ImageCard
              key={image.id}
              imageData={{
                name: image.title.fa_const,
                src: image.image ?? '',
              }}
              extension={{
                type: 'download',
              }}
            />
          ))}
        </Flex>
      ) : (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      )}
    </Box>
  );
};
